import React from "react";
import { Card } from "@/components/ui/card";

const About = () => {
  return (
    <main
      className="min-h-screen bg-[#F5F1E8] px-4 py-24 text-[#3E2723] md:px-6"
      data-testid="over-ons-page"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-10 md:flex-row md:items-start">

        {/* FOTO'S */}
        <div className="md:w-1/2 space-y-4">
          {/* Foto 1 */}
          <Card className="overflow-hidden rounded-3xl border border-[#3E2723]/10 bg-white/70 shadow-sm backdrop-blur-sm">
            <div className="aspect-[4/3] w-full overflow-hidden">
              <img
                src="/assets/aromacubana-2.png"
                alt="Ada en Maya van Aroma Cubana"
                className="h-full w-full object-cover"
              />
            </div>
          </Card>

          {/* Foto 2 */}
          <Card className="overflow-hidden rounded-3xl border border-[#3E2723]/10 bg-white/70 shadow-sm backdrop-blur-sm">
            <div className="aspect-[4/3] w-full overflow-hidden">
              <img
                src="/assets/aromacubana-1.jpeg"
                alt="Aroma Cubana – sfeerbeeld"
                className="h-full w-full object-cover"
              />
            </div>
          </Card>
        </div>

        {/* TEKST */}
        <div className="md:w-1/2">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#7ED956]">
            Over ons
          </p>
          <h1 className="mt-3 font-['Fraunces',_serif] text-3xl leading-tight md:text-4xl">
            Een stukje Cuba in het hart van Sint-Niklaas
          </h1>

          <div className="mt-4 space-y-4 text-sm leading-relaxed md:text-base">
            <p>
              Aroma Cubana werd opgericht door <strong>Ada Vázquez Ruz</strong> en haar
              mama <strong>Maya</strong>, beiden geboren en getogen in Cuba.
            </p>
            <p>
              De gerechten zijn geïnspireerd op familierecepten: eenvoudig, eerlijk
              en boordevol smaak — zoals ze die zelf kennen uit Cuba.
            </p>
            <p>
              Naast huisgemaakte gerechten serveren Ada en Maya ook Cubaanse
              cocktails, geselecteerde rums, koffie zoals in Cuba, verse sappen
              en echte Cubaanse sigaren.
            </p>
            <p>
              Bij Aroma Cubana draait alles om warmte, gastvrijheid en het gevoel
              dat je welkom bent als familie.
            </p>
          </div>
        </div>

      </div>
    </main>
  );
};

export default About;
